import { useEffect, useState } from "react";
import styled from "styled-components";

import Button from "src/components/core/Button";
import LabelSection from "src/components/core/LabelSection";
import ProductCard from "./ProductCard";
import ProductSuggestionAddDialog from "./ProductSuggestionAddDialog";

import EditIcon from "@mui/icons-material/Edit";

import { Black, White } from "src/styles/color";
import { hexToRgba } from "src/common/color";

import { useDialog } from "src/context/DialogContext";

import { getProductSuggest } from "src/api/landingPage";

const S = {};

S.BoxWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: ${White};
  box-shadow: 0px 4px 20px ${hexToRgba(Black, 0.1)};
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

S.ProductSuggestionContainer = styled.div`
  display: flex;
  overflow-x: auto;
`;

const WrapperProductCard = styled.div`
  padding-bottom: 1px;
  position: relative;
  margin-left: 12px;
  margin-right: 12px;
  margin-bottom: 40px;
  width: 200px;
  flex-shrink: 0;
`;

export const MAX_PRODUCT_SUGGESTION = 20;

const ProductSuggestion = () => {
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  const [productSuggestion, setProductSuggestion] = useState([]);

  const fetchProductSuggest = async () => {
    try {
      const result = await getProductSuggest();
      setProductSuggestion(result);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProductSuggest();
  }, []);

  return (
    <S.BoxWrapper>
      <LabelSection
        title="สินค้าโปรโมชั่น"
        description={`สินค้า ${productSuggestion.length}/${MAX_PRODUCT_SUGGESTION} รายการ`}
        actionMenu={() => (
          <Button
            startIcon={<EditIcon />}
            variant="secondary"
            size="large"
            sx={{
              minWidth: 200,
            }}
            onClick={() => {
              openDialog({
                type: "custom",
                customDialog: (
                  <ProductSuggestionAddDialog
                    onClose={() => closeDialog()}
                    onSuccess={async () => {
                      closeAllDialogs();
                      await fetchProductSuggest();
                    }}
                  />
                ),
              });
            }}
          >
            แก้ไข
          </Button>
        )}
      >
        <S.ProductSuggestionContainer>
          {productSuggestion.map((product, index) => (
            <WrapperProductCard>
              <ProductCard
                id={product?.product_choices?._id}
                brand={product?.user?.seller?.brand_name}
                price={product?.product_choices?.group_price}
                src={
                  product?.product_choices?.group_image?.product_display_image
                }
                srcHover={
                  product?.product_choices?.group_image?.product_closeup_image
                }
                itemcode={product?.item_code}
                itemname={product?.item_name}
                startprice={product?.product_choices?.group_price?.start_price}
                specialprice={
                  product?.product_choices?.group_price?.special_price
                }
                mode={product?.product_choices?.group_price?.is_start_price}
                cate={product?.category?.cate_th}
                view={product?.product_choices?.view_count}
                choice={0}
                partnername={product?.user?.seller?.company_name}
                choice_id={product?.product_choices?._id}
                discount={
                  product?.product_choices?.group_price?.reduce_percent
                    ? product?.product_choices?.group_price?.reduce_percent?.toFixed(
                        0
                      )
                    : null
                }
                sellerName={product?.user?.seller?.company_name}
                sellerLogo={product?.user?.seller?.profile_image}
                productType={product?.product_types
                  .map((data) => data.type_th)
                  .join(",")}
                size={{ ...product?.product_choices?.size }}
                isExclusiveDeal={product?.product_choices?.is_deal}
                isDelivery={product?.user?.seller?.is_delivery}
                isInstall={
                  product?.is_installer &&
                  product?.product_choices?.group_price?.install_price === 0
                }
                isSell={product?.user?.seller?.is_sell}
                isInstock={product?.product_choices?.is_instock}
              />
            </WrapperProductCard>
          ))}
        </S.ProductSuggestionContainer>
      </LabelSection>
    </S.BoxWrapper>
  );
};

export default ProductSuggestion;
